import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import About from "./components/About/About";
import Banner from "./components/Banner/Banner";
import ClinicalFacts from "./components/ClinicalFacts/ClinicalFacts";
import Contact from "./components/Contact/Contact";
import Feature from "./components/Feature/Feature";
import Footer from "./components/Footer/Footer";
import Menu from "./components/Menu/Menu";
import NotFound from "./components/NotFound/NotFound";
import QualityService from "./components/QualityService/QualityService";
import Services from "./components/Services/Services";
import Appointment from "./components/Appointment/Appointment";

function App() {
  return (
    <div>
      <Router>
          <Menu />
          <Switch>
            <Route exact path="/">
              <Banner />
              <Feature />
              <QualityService />
              <Services home />
              <ClinicalFacts />
            </Route>
            <Route path="/about">
              <About />
            </Route>
            <Route path="/services">
              <Services />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/appointment">
              <Appointment />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
          <Footer />
      </Router>
    </div>
  );
}

export default App;
